module.exports = __webpack_public_path__ + "static/media/section1-icon2.0a19ebc8.png";